"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 2019-04-11
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NumberRangeConverter_1 = require("../../../core/conversions/NumberRangeConverter");

var SelloutItemFilter_1 = require("../../model/sellout/SelloutItemFilter");

var SelloutItemFilterConverter_1 = require("./SelloutItemFilterConverter");
/**
 * @author Radek Beran
 * @author JMe
 */


var SelloutItemFilterConverterImpl =
/*#__PURE__*/
function (_SelloutItemFilterCon) {
  _inherits(SelloutItemFilterConverterImpl, _SelloutItemFilterCon);

  function SelloutItemFilterConverterImpl(numberRangeConverter) {
    var _this;

    _classCallCheck(this, SelloutItemFilterConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutItemFilterConverterImpl).call(this));
    _this.numberRangeConverter = numberRangeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutItemFilterConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        zoneId: conversions.asObjectOpt(source, 'zoneId', function (v) {
          return conversions.toDocumentReferenceId(v);
        }),
        siteIds: conversions.asObjectArray(source, 'siteIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        weighted: source.weighted,
        unitsPerSite: this.numberRangeConverter.toDocument(source.unitsPerSite, conversions),
        stockValue: this.numberRangeConverter.toDocument(source.stockValue, conversions),
        selloutVolume: this.numberRangeConverter.toDocument(source.selloutVolume, conversions),
        futurePromoInWeeks: source.futurePromoInWeeks,
        daysToExpiration: this.numberRangeConverter.toDocument(source.daysToExpiration, conversions),
        endDateFrom: conversions.asObjectOpt(source, 'endDateFrom', function (v) {
          return conversions.fromDate(v);
        }),
        endDateTo: conversions.asObjectOpt(source, 'endDateTo', function (v) {
          return conversions.fromDate(v);
        }),
        productExternalIds: source.productExternalIds ? conversions.asObjectArray(source, 'productExternalIds', function (id) {
          return id;
        }) : null,
        returnable: source.returnable
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutItemFilter_1.SelloutItemFilter(conversions.asObjectOpt(source, 'zoneId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asClassReferenceIdsSet(source, 'siteIds'), SelloutItemFilter_1.SelloutItemFilter.schema.weighted.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.unitsPerSite.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.stockValue.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.selloutVolume.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.futurePromoInWeeks.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.daysToExpiration.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.endDateFrom.valueOfField(source), SelloutItemFilter_1.SelloutItemFilter.schema.endDateTo.valueOfField(source), source.productExternalIds ? conversions.asObjectSet(source, 'productExternalIds', function (id) {
        return id;
      }) : null, SelloutItemFilter_1.SelloutItemFilter.schema.returnable.valueOfField(source));
    }
  }]);

  return SelloutItemFilterConverterImpl;
}(SelloutItemFilterConverter_1.SelloutItemFilterConverter);

SelloutItemFilterConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [NumberRangeConverter_1.NumberRangeConverter])], SelloutItemFilterConverterImpl);
exports.SelloutItemFilterConverterImpl = SelloutItemFilterConverterImpl;